import React, { Component } from 'react';
import PieChartComponent from '../chart/charts/PieChartComponent';
import LineChartComponent from '../chart/charts/LineChartComponent';
import DonutChartComponent from '../chart/charts/DonutChartComponent';
import BarChartComponent from '../chart/charts/BarChartComponent';
import TableChartComponent from '../chart/charts/TableChartComponent';
import { ChartType } from '@trlogic/ui-pack';
import { MetricItem, SegmentItem } from '../../domain/chart/ChartDomains';
import { ChartOptions } from 'chart.js';
import hash from 'object-hash';
import IndicatorChartComponent from '../chart/charts/IndicatorChartComponent';
import LanguageUtil from '../../util/LanguageUtil';

class ChartJsComponent extends Component<Props> {
  public render() {
    const { chartType, options } = this.props;
    const hashedOptions = hash(options || '');
    return (
      <div key={hashedOptions} className={`flex w-full h-[calc(100%-50px)] ${chartType != ChartType.TABLE && 'px-2'}`}>
        {this.getChartJsComponent()}
      </div>
    );
  }

  private isIndicatorData = (data: any): boolean => {
    if (data && Array.isArray(data)) {
      return data.length > 0;
    }
    return false;
  };
  private isChartJsData = (data: any) => {
    if (data && data instanceof Object && Object.hasOwn(data, 'datasets') && Object.hasOwn(data, 'labels')) {
      if (data.datasets.length > 0 && data.labels.length > 0) return true;
    }
    return false;
  };

  private getChartJsComponent = () => {
    const { chartType, data, chartName, segmentItem, metrics, options } = this.props;
    switch (chartType) {
      case ChartType.TABLE:
        if (!this.isChartJsData(data))
          return (
            <div className={'flex items-center justify-center w-full h-full'}>
              {LanguageUtil.get({ id: 'common.label.noDataAvailable', defaultMessage: 'No data available' })}
            </div>
          );
        return <TableChartComponent metrics={metrics} segmentItem={segmentItem} data={data} />;
      case ChartType.PIE:
        if (!this.isChartJsData(data))
          return (
            <div className={'flex items-center justify-center w-full h-full'}>
              {LanguageUtil.get({ id: 'common.label.noDataAvailable', defaultMessage: 'No data available' })}
            </div>
          );

        return <PieChartComponent options={options} data={data} />;
      case ChartType.DONUT:
        if (!this.isChartJsData(data))
          return (
            <div className={'flex items-center justify-center w-full h-full'}>
              {LanguageUtil.get({ id: 'common.label.noDataAvailable', defaultMessage: 'No data available' })}
            </div>
          );
        return <DonutChartComponent options={options} data={data} />;
      case ChartType.LINE_STACKED:
      case ChartType.LINE:
      case ChartType.AREA:
      case ChartType.AREA_STACKED:
        if (!this.isChartJsData(data))
          return (
            <div className={'flex items-center justify-center w-full h-full'}>
              {LanguageUtil.get({
                id: 'common.label.noDataAvailable',
                defaultMessage: 'No data available',
              })}
            </div>
          );
        return <LineChartComponent options={options} data={data} />;
      case ChartType.INDICATOR:
        if (!this.isIndicatorData(data))
          return (
            <div className={'flex items-center justify-center w-full h-full'}>
              {LanguageUtil.get({
                id: 'common.label.noDataAvailable',
                defaultMessage: 'No data available',
              })}
            </div>
          );
        return <IndicatorChartComponent values={data} metrics={metrics} />;
      default:
        if (!this.isChartJsData(data))
          return (
            <div className={'flex items-center justify-center w-full h-full'}>
              {LanguageUtil.get({
                id: 'common.label.noDataAvailable',
                defaultMessage: 'No data available',
              })}
            </div>
          );
        return <BarChartComponent options={options} data={data} />;
    }
  };
}

interface Props {
  chartType: ChartType;
  data: any;
  chartName: string;
  segmentItem?: SegmentItem;
  isDashboard?: boolean;
  metrics: MetricItem[];
  options?: ChartOptions;
}

export default ChartJsComponent;
